import React from 'react';
import {Button, Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {formatText} from 'presentation/utils';
import {translations} from 'presentation/translations-new';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {StyledStack} from './styles';
import {SubHeaderProps} from './types';

const {changeBeneficiary} = translations['pt-br'].commons;

export function SubHeader({handleAction}: SubHeaderProps) {
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(state => state.accountData);
	const {palette} = useTheme();

	return (
		<StyledStack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
			<Stack direction="row" alignItems="center" gap={1} sx={{overflow: 'hidden'}}>
				<Icon name="person-filled" size={20} color={palette.other.progressBar} />
				<Typography
					textOverflow="ellipsis"
					overflow="hidden"
					whiteSpace="nowrap"
					variant="body2">
					{formatText(nmSocialUsuarioC || nmUsuarioC)}
				</Typography>
			</Stack>
			<Button
				variant="text"
				size="small"
				sx={{color: palette.other.progressBar}}
				onClick={handleAction}>
				{changeBeneficiary}
			</Button>
		</StyledStack>
	);
}
